var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Breadcrumb',_vm._l((_vm.gen_bread),function(item,key){return _c('BreadcrumbItem',{key:key},[(item.icon)?_c('Icon',{attrs:{"custom":item.icon}}):_vm._e(),_vm._v(" "+_vm._s(item.name))],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }